import React from 'react';
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";

import Button from '../ui/Button';
import Card from '../ui/Card';
import TinyMCEEditor from "../ui/TinyMCEEditor";

const BlockForm = ({ 
  block = null, 
  onSubmit, 
  isSubmitting = false, 
  title = "Block Form",
  submitButtonText = "Save"
}) => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: block?.title || "",
      identifier: block?.identifier || "",
      content: block?.content || "",
      isActive: block?.isActive ?? true,
    },
  });

  const handleFormSubmit = async (data) => {
    try {
      await onSubmit(data);
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("Failed to process form");
    }
  };

  return (
    <div className="admin-block">
      <div className="admin-card">
        <div className="admin-card-header">
          <h2 className="admin-card-title">{title}</h2>
        </div>
      </div>

      <div className="admin-card">
        <Card className="content-section">
          <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
            {/* Title */}
            <div className="form-group">
              <label htmlFor="title">Title <span className="required-text">*</span></label>
              <input
                {...register("title", { required: "Title is required" })}
                className="w-full border rounded px-3 py-2"
                placeholder="Block title"
              />
              {errors.title && (
                <p className="input-error-text">{errors.title.message}</p>
              )}
            </div>

            {/* Identifier */}
            <div className="form-group">
              <label htmlFor="identifier">Identifier <span className="required-text">*</span></label>
              <input
                {...register("identifier", { required: "Identifier is required" })}
                className="w-full border rounded px-3 py-2"
                placeholder="Unique identifier"
              />
              {errors.identifier && (
                <p className="input-error-text">{errors.identifier.message}</p>
              )}
            </div>

            {/* Content */}
            <div className="form-group">
              <label className="block mb-1 font-medium">Content <span className="required-text">*</span></label>
              <Controller
                name="content"
                control={control}
                rules={{ required: "Content is required" }}
                render={({ field }) => (
                  <TinyMCEEditor
                    value={field.value}
                    onChange={field.onChange}
                  />
                )}
              />
              {errors.content && (
                <p className="input-error-text">{errors.content.message}</p>
              )}
            </div>

            {/* Active Status */}
            <div className="form-group">
              <label className="proskins-checkbox">
                <input
                  type="checkbox"
                  {...register('isActive')}
                />
                <span className="">Active</span>
              </label>
            </div>

            {/* Action Buttons */}
            <div className="details-actions">
              <button
                type="button"
                onClick={() => navigate("/admin/blocks")}
                className="btn btn-secondary btn-medium mr-2"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-primary btn-medium save-btn"
              >
                {isSubmitting ? "Saving..." : submitButtonText}
              </button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default BlockForm;
